// extracted by mini-css-extract-plugin
module.exports = {"tag":"SubscriptionStatusTag_tag__2PFRT","alertContainer":"SubscriptionStatusTag_alertContainer__2Zjy8","successContainer":"SubscriptionStatusTag_successContainer__1Amxt"};